export default __webpack_public_path__ + "static/media/Remove.90b51bb5.svg";